import { render, staticRenderFns } from "./historyUpdateModal.vue?vue&type=template&id=14cd4f4c&scoped=true&"
import script from "./historyUpdateModal.vue?vue&type=script&lang=js&"
export * from "./historyUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cd4f4c",
  null
  
)

export default component.exports